import React from 'react';
import { IconType } from '../../types';

export const TriangleArrowIcon = ({
  width = 24,
  height = 24,
  color = '#8B98B2',
}: IconType) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform={`translate(${width / 2}, ${height / 2})`}>
      <path
        d="M-3.87789 -3.29381C-4.26841 -3.68433 -4.90195 -3.68395 -5.29248 -3.29343C-5.68302 -2.90291 -5.68341 -2.26935 -5.29288 -1.87882L0 3.41406L5.29289 -1.87882C5.68341 -2.26935 5.683 -2.90291 5.29247 -3.29343C4.90195 -3.68395 4.26841 -3.68433 3.87789 -3.29381L0 0.58408L-3.87789 -3.29381Z"
        fill={color}
      />
    </g>
  </svg>
);
